import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ApiService } from './../../../../../Services/api.service';
import { LoaderService } from './../../../../../Services/loader.service';
import { StorageService } from "./../../../../../Services/storage.service"
import { CommonServices } from '../../../../../Services/common.service';
import { ExcelExportService } from './../../../../../Services/excel.service';
import { S3BudgetService } from "./../../../../../Services/s3Budget.service";
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { resolve } from 'dns';
import { rejects } from 'assert';
import { SubjectService } from 'src/app/Services/subject-services';
@Component({
  selector: 'app-night-ride-reports',
  templateUrl: './night-ride-reports.component.html',
  styleUrls: ['./night-ride-reports.component.css']
})
export class NightRideReportsComponent implements OnInit {
  public formFilters: any = FormGroup;
  @ViewChild('search') searchTextBox: ElementRef;

  selectFormControl = new FormControl();
  public timeIntravel: any = {
    1: 10,
    2: 60,
    3: 300,
    4: 600
  };
  public timeIntervalSec: any = {
    10: '10 Seconds',
    60: '1 Minute',
    300: '5 Minutes',
    600: '10 Minutes',
  }
  public excelData:any = {};
  public allVehDownload: boolean=false;
  public tableData:any = [];
  public cols = [
    { key: '#', display: '#' },
    { key: 'DateTime', display: 'Date / Time', headerConfig: { isDefault: true } },
    { key: 'Location', display: 'Location' },
    { key: 'Status', display: 'Status' },
    { key: 'Speed', display: 'Speed (km/h)', style: 'align:center', headerConfig: { isDefault: true } },
    { key: 'Distance', display: 'Total distance (km)', headerConfig: { isDefault: true } },

  ];
  public noDataFoundEnable: boolean = false;
  public localStorage;
  public processedData: any = {};
  public objectKeys = Object.keys;
  public totalDistance: any = 0;
  public myDate = new Date();
  public maxDate: any;
  searchTextboxControl: any;
  public enableAllOption: boolean = true;
  public currentDayError=false;
  public todayError=false;
  public dataFound=false;

  // selectFormControl: any;
  data: any;
  constructor(
    public fb: FormBuilder,
    public comService: CommonServices,
    public api: ApiService,
    public loader: LoaderService,
    public excel: ExcelExportService,
    public storage: StorageService,
    public s2Service: S3BudgetService,
    private subject: SubjectService
  ) {
    this.maxDate = new Date(
      this.myDate.getFullYear(),
      this.myDate.getMonth(),
      this.myDate.getDate() - 1
    );
    this.localStorage = this.storage.get('vendorID_orgID');

    this.getRegNos();
    this.getVehicleDetails();
  }

  public vehicleRegNos: any
  public showTable: boolean;
  public vehicles;

  getVehicleDetails() {

    const obj = {
      orgID: localStorage.orgID,//this.orgID == null ? this.storage.get('vendorID_orgID').orgID : this.orgID,
      vendorID: localStorage.vendorID //this.vendorID == null ? this.storage.get('vendorID_orgID').vendorID : this.vendorID,
    };
    this.api.transportManagerVehicleList(obj).then((res: any) => {
      if (res.status == 'success') {
        this.vehicles = res.data;
      }
    }).catch((err) => {
      console.log(err);
    });

  }

  filteredOptions: Observable<any[]>;
  selectedValues = [];

  ngOnInit(): void {
     this.storage.setData({report_submit:false});
  }

  getRegNos() {

    this.api.getOrgVehicleRegNos({}).then((res: any) => {
      if (res.status == 'success') {
        this.vehicleRegNos = res.data;
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  async getVehicleEncryptRegNo(regNo) {
    this.loader.hide();
    return new Promise((resolve, rejects) => {
      this.api.getVehicleRegNo({ vehRegNo: regNo }).then((res) => {
        if (res['status'] == 'success') resolve(res['data']);
        else rejects(res['data'])
      })
    })
  }
  writeExcelData(startDate, endDate, veh, data) {

  }


  areDatesEqual(date1: Date, date2: Date): boolean {
    return date1.getFullYear() === date2.getFullYear() &&
           date1.getMonth() === date2.getMonth() &&
           date1.getDate() === date2.getDate();
  }

  async submitForm(obj: any) {

     this.storage.setData({report_submit:true})
    this.allVehDownload=false;
    this.currentDayError=false;
    this.todayError=false;
    this.dataFound=false;
    this.tableData=[]

    try {
      if (obj) {
        let filterValues = obj.formFilds;
        this.showTable = false;
        this.currentDayError=false;
        this.excelData = [];
        let allTrue = false;
        this.totalDistance = 0;
        this.noDataFoundEnable = false;
        this.loader.show();
        let selectedVehs
        const vehicle = filterValues.selectedVehicle;
        if (obj.formFilds.selectedVehicle == 'ALL') {
          allTrue = true
          selectedVehs = this.vehicles
            .filter(veh => veh.vehRegNo)  // Ensure vehRegNo exists
            .map(veh => veh.vehRegNo)     // Extract vehRegNo
            .sort();
          if (selectedVehs.length > 0) { filterValues['selectedVehs'] = selectedVehs }
        } else {
          filterValues['selectedVehs'] = obj.formFilds.selectedVehicle
        }
        const startDate = new Date(filterValues.sDate + '');
        const endDate = new Date(filterValues.eDate + '');

        // if(this.areDatesEqual(startDate,today)){ //check if the selected day is today
        //   if(today.getHours()<22){
        //     this.todayError=true;
        //   }
        // }
        const arr: any = []
        let getDaysArray: any = function (start, end) {
          for (const dt: Date = new Date(start); dt <= end; dt.setDate(dt.getDate() + 1)) {
            const date = new Date(dt);
            arr.push(date.getFullYear() + '/' + pad(date.getMonth() + 1) + '/' + pad(date.getDate()));
          }
          return arr;
        };
        const pad = (num) => {
          return num > 9 ? num : '0' + num;
        };

        let currentDate = new Date();
        const currentDateString = currentDate.getFullYear() + '/' + pad(currentDate.getMonth() + 1) + '/' + pad(currentDate.getDate());
        const start = startDate.getFullYear() + '/' + pad(startDate.getMonth() + 1) + '/' + pad(startDate.getDate());
        let end =endDate.getFullYear() + '/' + pad(endDate.getMonth() + 1) + '/' + pad(endDate.getDate()+1);
        // currentDateString === start ? end = endDate.getFullYear() + '/' + pad(endDate.getMonth() + 1) + '/' + pad(endDate.getDate() + 1) : 
        // end = endDate.getFullYear() + '/' + pad(endDate.getMonth() + 1) + '/' + pad(endDate.getDate()+1)

        let daylist: any = getDaysArray(new Date(start), new Date(end));
        let dayCount=daylist.length;
        const timeIntravel = filterValues.timeInteravel ? this.timeIntravel[filterValues.timeInteravel] : 60;
        // const vehicleList = await this.comService.vehicleToObject(this.vehicles, vehicle);
        // const vehLen = this.objectKeys(vehicleList);   console.log('vehicleList ', vehLen)
        let vehLen = [];
        if (!Array.isArray(filterValues['selectedVehs'])) vehLen = [filterValues['selectedVehs']];
        else vehLen = filterValues['selectedVehs'];

        daylist = [...new Set(daylist)];

        const checkCurrentDay = (date) => {
          var inputDate = new Date(date);
          var todaysDate = new Date();
          if (inputDate.setHours(0, 0, 0, 0) == todaysDate.setHours(0, 0, 0, 0)) return true;
          else return false;
        };

        let vehRegArray = [];
        for (let veh = 0; veh < vehLen.length; veh++) {
          vehRegArray.push(vehLen[veh]);
        }

        let vehRegEncryKey = await this.getVehicleEncryptRegNo(vehRegArray).catch((e) => { console.log('unable to veh reg no'); })
        
        for (let veh = 0; veh < vehLen.length; veh++) {
          this.loader.show();
          let pdata: any = [], excel:any = [];
          if (this.processedData[vehLen[veh]] == undefined) { this.processedData[vehLen[veh]] = {}; }
          for (let day = 0; day < daylist.length; day++) {
            let checkDay = checkCurrentDay(daylist[day]);
             console.log('checkDay===',checkDay);
            if (this.processedData[vehLen[veh]][daylist[day]] == undefined) this.processedData[vehLen[veh]][daylist[day]] = {};
            if (!checkDay) {
              //this.loader.show();
              const splitDate = daylist[day].split('/');
              const date = splitDate[2] + splitDate[1] + splitDate[0].slice(-2);
              if (vehRegEncryKey[vehLen[veh]] != null) {
                const url = date + '/' + vehRegEncryKey[vehLen[veh]] + '.z';
                const res = await this.api.readS3Data(url).catch((e) => { });
                 console.log('checkDayres===',res);
                if (JSON.stringify(res) != '{}' && res != undefined && res != null && res != '') {
                  let notCurrentDay: string;
                  day == 0 ? notCurrentDay = 'notCurrentDay' : notCurrentDay = 'currentDay';
                  let tempData: any = await this.processData(res, timeIntravel, notCurrentDay);
                   console.log('checkDayrestempData===',tempData);
                  if (JSON.stringify(tempData) != '{}' && tempData != undefined && tempData != null && tempData != '' && tempData?.xldata.length > 0) {
                     
                    if (excel.length > 0) {
                      tempData['xldata'].forEach((xl: any) =>
                        excel.push(xl))
                    }
                    else {
                      excel = [...excel, ...tempData['xldata']];
                    }
                    pdata = [...pdata, ...tempData['data']];


                    if (allTrue == false) {
                     // this.showTable = true;
                      this.noDataFoundEnable = false;
                    }
                  }
                  else {
                    let tempData: any = {
                      "data": [
                        {
                          DateTime: "",
                          Location: 'No data found',
                          Status: '',
                          Distance: '',
                          Speed: "",
                          ts: '',
                          gpsts: ''
                        }
                      ],
                      "xldata": [
                        {
                          "value": [
                            "",
                            'No data found',
                            '',
                            '',
                            '',
                          ]
                        }
                      ]
                    }
                    if (excel.length > 0 && tempData?.xldata.length > 0) {
                      tempData['xldata'].filter(xl =>
                        excel.push(xl)
                      )
                      if (allTrue == false) {
                       // this.showTable = true;
                        this.noDataFoundEnable = false;
                      }
                    } else {
                      if (allTrue == false) {
                        this.showTable = false;
                        //this.noDataFoundEnable = true;
                      }
                    }
                  }

                } else {
                  if (allTrue == true) {
                    let tempData: any = {
                      "data": [
                        {
                          DateTime: '',
                          Location: 'No data found',
                          Status: '',
                          Distance: '',
                          Speed: "",
                          ts: '',
                          gpsts: ''
                        }
                      ],
                      "xldata": [
                        {
                          "value": [
                            '',
                            'No data found',
                            '',
                            '',
                            '',
                          ]
                        }
                      ]
                    }
                    excel = [...excel, ...tempData['xldata']];
                  } else {
                    let tempData: any = {
                      "data": [
                        {
                          DateTime: '',
                          Location: 'No data found',
                          Status: '',
                          Distance: '',
                          Speed: "",
                          ts: '',
                          gpsts: ''
                        }
                      ],
                      "xldata": [
                        {
                          "value": [
                            '',
                            'No data found',
                            '',
                            '',
                            '',
                          ]
                        }
                      ]
                    }
                    if (excel.length > 0) {
                      tempData['xldata'].filter(xl =>
                        excel.push(xl)
                      )
                      if (allTrue == false) {
                        //this.showTable = true;
                        this.noDataFoundEnable = false;
                      }
                    } else {
                      if (allTrue == false) {
                        this.showTable = false;
                        //this.noDataFoundEnable = true;
                      }
                    }
                  }
                }
              }
            } else {
             // this.loader.show();
              let obj = {
                vehRegNo: vehLen[veh],
                date: (allTrue && dayCount==2 || currentDateString===start) ? new Date().setHours(22, 0, 0, 0):new Date().setHours(0, 0, 0)
              };
              if (this.processedData[vehLen[veh]][daylist[day]] == undefined) { this.processedData[vehLen[veh]][daylist[day]] = {}; }
              let getData = await this.comService.currentDayTrackingData(obj).catch((e) => {
                if(!this.todayError){
                  if(e.err==='Getting empty data'){
                    console.log('e.err',);
                    //this.currentDayError=true
                    return null;
                  }
                }
                });
                 console.log('gettrackingdata',getData);
              if (JSON.stringify(getData) != '{}' && getData != undefined && getData != null && getData != '') {
                let tmpData: any = await this.processData(getData, timeIntravel, 'currentDay');
                console.log("tmpData====",tmpData)
                if (JSON.stringify(tmpData) != '{}' && tmpData != undefined && tmpData != null && tmpData != '' && tmpData?.data.length > 0 && tmpData?.xldata.length > 0) {
                  if (excel.length > 0) {
                    tmpData['xldata'].filter(xl =>
                      excel.push(xl)
                    )
                  } else {
                    excel = [...excel, ...tmpData['xldata']];
                  }
                  pdata = [...pdata, ...tmpData['data']];
                  if (allTrue == false) {
                    //this.showTable = true;
                    this.noDataFoundEnable = false;
                  }
                } else {
                  if (allTrue == false) {
                    this.showTable = false;
                    //this.noDataFoundEnable = true;
                  }
                }
              } else {
                if (allTrue == true) {
                 // this.showTable = true;
                  let tempData: any = {
                    "data": [
                      {
                        DateTime: "",
                        Location: 'No data found',
                        Status: '',
                        Distance: '',
                        Speed: "",
                        ts: '',
                        gpsts: ''
                      }
                    ],
                    "xldata": [
                      {
                        "value": [
                          '',
                          'No data found',
                          '',
                          '',
                          '',
                        ]
                      }
                    ]
                  }
                  excel = [...excel, ...tempData['xldata']];
                } else {
                  if (allTrue == false) {
                    this.showTable = false;
                    //this.noDataFoundEnable = true;
                  }
                }
              }
            }
    
          this.processedData[vehLen[veh]][daylist[day]] = pdata;
          }
          if (excel.length > 0) {
            let rowCount = 2;
            let endCell = 'F';
            let customizedData:any = [];
            let titleRow = {
              value: ['Night Drive Report'],
              font: {
                name: 'Cambria', family: 4, size: 16, bold: true,
                color: { argb: 'FFFFFFFF' },
              },
              mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
              alignment: {
                cell: `A${(rowCount - 1) + ''}`, value: { vertical: 'middle', horizontal: 'center' },
              },
              fill: {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '966462AF' },
                bgColor: { argb: '966462AF' }
              },
            }

            customizedData.push(titleRow);

            rowCount = rowCount + 4;

            let subtitleRow = {
              value: [
                "Vehicle            : " + String(vehLen[veh]).toUpperCase() + "\n" +
                "Start Date       : " + this.comService.timestampToDate(new Date(startDate).getTime(), 'DMY') + "\n" +
                "End Date         : " + this.comService.timestampToDate(new Date(end).getTime(), 'DMY') + "\n"
              ],
              font: { name: 'Cambria', family: 4, size: 12, },
              mergeCells: `A${(rowCount - 3) + ''}:${endCell + rowCount + ''}`,
            }
            customizedData.push(subtitleRow);
            rowCount = rowCount + 1;

            let headerRow =
            {
              value: ['S No', 'Date / Time', 'Location', 'Status', 'Speed', 'Total distance'],
              fill: {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFFF00' },
                bgColor: { argb: 'FF0000FF' }
              },
              font: { bold: true },
              border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
            }
            customizedData.push(headerRow);

            let sNo = 1;
            let foundNoData = false;

            excel = excel.filter((item:any) => {
              rowCount++;
              item['value'] = [sNo, ...item['value']];
              if (item['value'][2] === 'No data found') {
                item['value'][0]='';
                if (!foundNoData) {
                  foundNoData = true;
                  return true;
                }
                return false;
              }else{
                this.dataFound=true;
              }
              let colorCode = "FF008000";
              if (item['value'][3] === 'Halt') colorCode = "FFFF0000";

              item['cellConfig'] = {
                cells: [
                  { cell: `D${rowCount}`, font: { color: { argb: colorCode } } },
                  { cell: `E${rowCount}`, font: { color: { argb: colorCode } } }
                ]
              };

              sNo++;
              return !foundNoData;
            });

            let n=excel.length;
           if(n>1 && excel[n-1].value[2]==='No data found'){
            excel.pop();
           }
            customizedData.push(...excel);

            if(customizedData[3].value[2]!='No data found'){
              if (this.excelData[vehLen[veh].toUpperCase()] == undefined) {
                this.excelData[vehLen[veh].toUpperCase()] = {};
              }
                this.excelData[vehLen[veh].toUpperCase()] = {
                  customizedData: customizedData,
                  data: {
                    columWith: [{ colNo: 1, width: 10 }, { colNo: 2, width: 20 }, { colNo: 3, width: 100 }, { colNo: 4, width: 20 }, { colNo: 5, width: 20 }, { colNo: 6, width: 20 }]
                }
              };
            }
          }
        }

        if (!vehLen.includes('ALL') && vehLen.length <= 1) {
          // this.tableData.sort(function (x, y) {
          //   return x.gpsts - y.gpsts;
          // });

          console.log("CallSingle vehicle=====",this.tableData.length);
          if(this.tableData.length==0){
             this.showTable = false;
             this.noDataFoundEnable=true;

          }else{
          this.showTable = true;
          this.allVehDownload=false;
          }
           this.loader.hide(); 
            this.subject.broadcast({
              for: 'progress_handle',
              payload: true
            })
             this.storage.setData({report_submit:false})
         
        } else {
            console.log("CallAll vehicles=====");
          if(this.dataFound){
           // this.allVehDownload = true;
            this.noDataFoundEnable=false;
            this.currentDayError=false;
          }else{
            this.noDataFoundEnable=true;
          }
        }
        //this.showTable = true;
        //this.loader.hide();

        if (allTrue == true) {
           console.log("CallAll vehicles1=====");
          if(this.dataFound){
             this.allVehDownload = true;
            //this.showTable = true;
            this.noDataFoundEnable = false;
            this.currentDayError=false;
          }else{
            console.log("CallAll vehicleselse=====");
            this.showTable=false;
            this.noDataFoundEnable=true;
          }
        
             this.subject.broadcast({
              for: 'progress_handle',
              payload: true
            })
             this.storage.setData({report_submit:false})

        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  processData(data: any, minInterval: any, dayCheck: any) {
    return new Promise((resolve, reject) => {
      try {
        this.totalDistance=0;
        const procesedData: any = [];
        const sortingData = {};
        if (data && data.length > 0) {
          data.map((item) => {
            if (item.gpsts != undefined) {
              item.date = this.comService.timestampToDate(item.gpsts, 'DMY H:M:S');
              sortingData[item.gpsts] = item;
            }
          });
        }
        else {
          this.noDataFoundEnable = true;
        }
        let totalDis: any = 0;
        const objKeys = this.objectKeys(sortingData);
        if (objKeys && objKeys.length) {
          let ind = 1;
          const temp: any = [];
          const tempEx = [];
          for (let i = 0; i < objKeys.length; i++) {
            let prevKey:any = null, next:any = null, currentKey = objKeys[i], pre:any = null;

            if (i > 0) { prevKey = procesedData[procesedData.length - 1]; }
            if (objKeys[i + 1]) { next = objKeys[i + 1]; }
            let curdis = 0;
            if (i > 0) {
              pre = objKeys[i - 1];
              const lat1 = parseFloat(sortingData[currentKey].lat);
              const lat2 = parseFloat(sortingData[pre].lat);
              const lng1 = parseFloat(sortingData[currentKey].lng);
              const lng2 = parseFloat(sortingData[pre].lng);
              if ((lat1 == lat2) && (lng1 == lng2)) { curdis = 0; } else {
                const radlat1 = Math.PI * lat1 / 180.0;
                const radlat2 = Math.PI * lat2 / 180.0;
                const theta = lng1 - lng2;
                const radtheta = Math.PI * theta / 180.0;
                let dist: any = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
                if (dist > 1) {
                  dist = 1;
                }
                dist = Math.acos(dist);
                dist = dist * 180 / Math.PI;
                dist = dist * 60 * 1.1515;
                dist = (dist * 1.609344);
                curdis = parseFloat(dist);
              }
            }
            totalDis = parseFloat(totalDis) + curdis;
            this.totalDistance = parseFloat(this.totalDistance) + curdis;
            var diffInterval: boolean = true;
            if (i > 0) {
              const diff = Math.abs(sortingData[currentKey]?.gpsts * 1000 - prevKey?.gpsts * 1000);
              const minutes = Math.round(diff / 1000);
              
              if (minutes >= minInterval) {
                diffInterval = true;
              } else if (minutes < minInterval) {
                diffInterval = false;
              }
            }
            if (diffInterval && diffInterval != undefined && parseInt(sortingData[currentKey].spd) > 5) { //checking speed to be more than 5km/hr
              if (dayCheck == 'currentDay') {
                console.log("Currentdayif")
                if (parseInt(sortingData[currentKey].stime) < 6) { //beforw 6:00 am
                  if (parseInt(sortingData[currentKey].spd) < 0) sortingData[currentKey].spd = '0';
                  const status = parseInt(sortingData[currentKey].spd) > 5 ? 'Movement' : 'Halt';
                  const res = {
                    sNo: ind,
                    DateTime: sortingData[currentKey].date,
                    Status: status,
                    Location: String(sortingData[currentKey].near).replace('\r', ''),
                    Speed: Number(sortingData[currentKey].spd),
                    Distance: Number(this.totalDistance.toFixed(2))
                  };
                  const rowVal = {
                    value: [sortingData[currentKey].date, String(sortingData[currentKey].near).replace('\r', ''), status, Number(sortingData[currentKey].spd), Number(this.totalDistance.toFixed(2))]
                  };
                  tempEx.push(rowVal);
                  temp.push(res);
                  const tdata = JSON.parse(JSON.stringify(res));
                  tdata.ts = sortingData[currentKey].gpsts;
                  tdata.gpsts = tdata.ts;
                  procesedData.push(tdata);
                  this.tableData.push(res);
                  ind++;
                }
              } else {
                 console.log("Currentdayelse");
                if (parseInt(sortingData[currentKey].stime) > 22) { //after 10.00 pm onwards
                  if (parseInt(sortingData[currentKey].spd) < 0) sortingData[currentKey].spd = '0';
                  const status = parseInt(sortingData[currentKey].spd) > 5 ? 'Movement' : 'Halt';
                  const res = {
                    sNo: ind,
                    DateTime: sortingData[currentKey].date,
                    Status: status,
                    Location: String(sortingData[currentKey].near).replace('\r', ''),
                    Speed: Number(sortingData[currentKey].spd),
                    Distance: Number(this.totalDistance.toFixed(2))
                  };
                  const rowVal = {
                    value: [sortingData[currentKey].date, String(sortingData[currentKey].near).replace('\r', ''), status, Number(sortingData[currentKey].spd), Number(this.totalDistance.toFixed(2))]
                  };
                  tempEx.push(rowVal);
                  temp.push(res);
                  const tdata = JSON.parse(JSON.stringify(res));
                  tdata.ts = sortingData[currentKey].gpsts;
                  tdata.gpsts = tdata.ts;
                  procesedData.push(tdata);
                  this.tableData.push(res);
                  ind++;
                }

              }
              // parseInt(sortingData[currentKey].stime) > 21
              // if(parseInt(sortingData[currentKey].stime)<7){
              // }
            }
            if ((objKeys.length - 1) == i) {
              //this.loader.show();

              resolve({ data: procesedData, xldata: tempEx });
            }
          }
        } else {
          resolve({ data: [], xldata: [] });
        }

      } catch (error) {
        console.log(error);
        reject(error);
      }
    });

  }
  downloadXL() {
    console.log('excel data===>', this.excelData);
    let time = new Date().getTime()
    this.excel.generateExcel(this.excelData, 'Night_Drive_Report_' + this.comService.timestampToDate(time, 'DMY') + '.xlsx');
  }

}
